import React from 'react'
import styled from 'styled-components'
import api from '../../api'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import RichText from '../../components/RichText'
import Colors from '../../assets/styles/Colors'

const Consent: React.FC<{
  dialog?: boolean
}> = ({ dialog = false }) => {
  const { data: webDocuments, isLoading: isWebDocumentsLoading } = api.useGetWebPageQuery('consent')
  return isWebDocumentsLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {dialog ? (
        <DialogBlock
          style={{
            padding: dialog === true ? '0px' : '20px',
          }}
        >
          <RichText html={webDocuments?.body || ''} />
        </DialogBlock>
      ) : (
        <Container>
          <Content>
            <RichText html={webDocuments?.body || ''} />
          </Content>
        </Container>
      )}
    </Wrapper>
  )
}
//
const DialogBlock = styled.div`
  position: absolute;
  z-index: 111111111111;
  background-color: ${Colors.white};
  padding: 20px;
`
const Content = styled.div`
  padding-block: 50px;
`
const Wrapper = styled.div``
//
export default Consent
